import * as React from 'react';
const TalloniScrepolatiIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}`}</style>
    </defs>
    <path
      d="M75.51 65.46a52 52 0 0 0 3.7 6.78c11.23 17.14 15.83 23.74 12.03 31.06-3.8 7.33-5.84 15.97 1.9 17.58s12.27-.44 19.28 7.47 15.04 6.74 22.64 5.42c7.59-1.32 8.76-8.06 3.8-10.7-4.97-2.64-8.09.33-14.31-9.52-7.07-11.2-6.44-10.49-9.93-18.41-3.44-7.8-7.17-15.76-9.59-35.86"
      style={{
        fill: 'none',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '3.89px',
        stroke: primaryColor || '#282828',
      }}
    />
    <path
      d="m80.3 117.09-4.81 6.76-5.54-1.31-.4-4.48-3.01-3.34 1.3-5.54 6.52 2.13 4.4-1.3-.58 3.66zM84.77 126.62l-8.14-.16-1.14-2.61M76.05 140.06l3.01-6.6-2.43-7"
      className="prefix__cls-1"
    />
    <path
      d="m69.95 122.54-2.44 2.93-.66 2.77 1.14 2.61 1.62 7.98M84.77 126.62l1.3 4.4-7.01 2.44M60.74 130.6l2.53-2.04 3.58-.32M66.54 114.72l-8.32 7.98M67.84 109.18l-3.82-2.36"
      className="prefix__cls-1"
    />
    <path
      d="M78.74 101.54c-3.3-.42-6.14.32-6.14.32-9.02 2.51-15.25 11.18-14.38 20.84.98 10.89 10.6 18.91 21.49 17.93 4.54-.41 8.58-2.32 11.67-5.19 0 0 1.05-1.06 2.22-2.49"
      className="prefix__cls-1"
    />
  </svg>
);
export default TalloniScrepolatiIcon;
